if (PJQ.app.module === PJQ.constants.modules.PROJECTLIST) {
	PJQ.app.addOldRoutes([
		{
			route: '',
			name: 'default',
			callback: function () {
				PJQ.app.router.navigate('projects', {
					trigger: true,
					replace: true
				});
			}
		}
	]);
}

PJQ.modules.projectsList = {
	routes: [
		{
			route: 'projects',
			name: 'projects',
			callback: function () {
				PJQ.app.session.project = null;
				if (PJQ.app.module === PJQ.constants.modules.APP) {
					if (PJQ.app.session.get('ownsPortal')) {
						PJQ.app.initNavigator({
							activeItem: "myprojects"
						});
					}
					else {
						PJQ.app.initNavigator();
					}
				}
				else {
					PJQ.app.view.renderView(PJQ.views.projects.MyProjectList);
				}
			}
		},
		{
			route: 'myprojects',
			name: 'myprojects',
			callback: function () {
				PJQ.app.session.project = null;
				PJQ.app.initNavigator({
					activeItem: "myprojects"
				});
			}
		},
		{
			route: 'projectinvites',
			name: 'projectinvites',
			callback: function () {
				PJQ.app.session.project = null;
				PJQ.app.initNavigator({
					activeItem: "projectinvites"
				});
			}
		},
		{
			route: 'biddingprojects',
			name: 'biddingprojects',
			callback: function () {
				PJQ.app.session.project = null;
				PJQ.app.initNavigator({
					activeItem: "biddingprojects"
				});
			}
		}
	]
};

PJQ.app.addRoutes(PJQ.modules.projectsList.routes);